module.exports = __webpack_public_path__ + "media/images/bnr_referral_s_pc-6b0dfceb27a426af2598632d3e6d1ee0.jpg";